import type {
	SettingsFlow,
	UpdateSettingsFlowBody,
	UpdateSettingsFlowWithPasswordMethod,
} from "@ory/kratos-client";
import type React from "react";
import { Flow } from "~/components/KratosFlow";
import { validatePassword } from "~/validator";

interface Props {
	flow: SettingsFlow;
	onSubmit: (values: UpdateSettingsFlowBody) => Promise<void>;
}

export const PasswordSettings: React.FC<Props> = ({ flow, onSubmit }) => {
	return (
		<section className="mt-12">
			<h2 className="font-normal text-xl">PASSWORD</h2>
			<Flow<UpdateSettingsFlowWithPasswordMethod & { method: "password" }>
				onSubmit={onSubmit}
				flow={flow}
				only="password"
				setLabelTexts={[
					{
						query: { name: "password", type: "password" },
						value: "new password",
					},
					{
						query: { name: "method", type: "submit", value: "password" },
						value: "Update Password",
					},
				]}
				nodeDisablers={[
					{
						target: { name: "method", value: "password" },
						keys: ["password"],
						allowEmpty: false,
						allowNotChanged: false,
						validators: [
							{
								key: "password",
								validate: (value): boolean => {
									if (typeof value !== "string") return false;
									return validatePassword(value);
								},
							},
						],
					},
				]}
			/>
		</section>
	);
};
